import {AlertCircle, CheckCircle2, Info} from "lucide-react";
import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {cn} from "@/lib/utils";

type Props = {variant?: "info" | "error" | "success"; title?: string; children: React.ReactNode};

const icons = {
  info: Info,
  error: AlertCircle,
  success: CheckCircle2
};

export function AdminAlert({variant = "info", title, children}: Props) {
  const Icon = icons[variant];
  return (
    <Alert variant={variant === "error" ? "destructive" : "default"} className={cn(variant === "success" && "border-emerald-200 bg-emerald-50 text-emerald-900")}>
      <Icon className="h-4 w-4" />
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}
